<template>
    <div id="wine-month">
        <div class="admin-wine-month-wrap">
            <div class="admin-wine-month-pad">
                <div class="admin-wine-month-header">
                    <div class="admin-wine-month-bar">
                        <div v-for="year in dataYears" :key="year" :id="year" v-on:click="currentYear=year; setupWines()" class="admin-wine-month-bar-cell">{{year}}</div>
                    </div>
                </div>
                <div id="admin-wine-all-months" class="admin-wine-month-all">
                    <div :id="'month'+month[0]" v-for="month in dataMonths" :key="month[0]" class="admin-wine-month-single">
                        <div class="admin-wine-month-single-header">{{month[1]}}</div>
                        <div class="admin-wine-month-single-wine red-text">None</div>
                        <div class="admin-wine-month-single-body">
                            <div v-on:click="showEditModal(); currentMonth=month[0]; currentCell=$event.target.parentNode.parentNode" class="admin-wine-month-change">Change</div>
                            <!-- <select name="" @change="onSelect($event)">
                                <option value="none">None</option>
                                <option v-for="wine in wines" :key="wine.id" :value="wine.id">{{ wine.name }}</option>
                            </select> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="editModal" id="admin-wine-month-edit-modal">
            <div class="admin-wine-month-edit-modal-content">
                <div class="admin-wine-month-edit-modal-title">
                    <select name="" @change="onSelect($event)">
                        <option value="none">None</option>
                        <option v-for="wine in wines" :key="wine.id" :value="wine.id">{{ wine.name }}</option>
                    </select>
                </div>
                <div v-on:click="onSave($event)" class="admin-wine-month-edit-modal-button delete-button-blue">Save</div>
                <div v-on:click="closeEditModal()" class="admin-wine-month-edit-modal-button delete-button-blue">Cancel</div>
            </div>
        </div>
    </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
    data() {
        return {
            dataMonths: [[1, "Janúar"], [2, "Febrúar"], [3, "Mars"], [4, "Apríl"], [5, "Maí"], [6, "Júní"], [7, "Júlí"], [8, "Ágúst"], [9, "September"], [10, "Október"], [11, "Nóvember"], [12, "Desember"]],
            dataYears: [],
            currentYear: 0,
            currentMonth: 0,
            currentWine: "",
            currentWineName: "",
            editModal: false,
            currentCell: null,
            fb
        }
    },
    computed: {
        ...mapState(['months', 'wines'])
    },
    methods: {
        onSelect: function(event) {
            var id = event.target.value
            this.currentWine = id
            var name = event.target.options[event.target.selectedIndex].text
            this.currentWineName = name
        },
        showEditModal: function() {
            this.editModal = true
        },
        closeEditModal: function() {
            this.editModal = false
        },
        onSave: function() {
            var found = false
            this.months.forEach(monthlyWine => {
                if (monthlyWine.month == this.currentMonth && monthlyWine.year == this.currentYear) {
                    var id = monthlyWine.id
                    fb.db.collection("months").doc(id).update({
                        month: this.currentMonth,
                        year: this.currentYear,
                        wineid: this.currentWine,
                    })
                    found = true
                }
            });
            if (found == false) {
                fb.monthsCollection.add({
                    month: this.currentMonth,
                    year: this.currentYear,
                    wineid: this.currentWine,
                })
            }
            this.currentCell.childNodes[1].innerHTML = ""
            this.currentCell.childNodes[1].innerHTML = this.currentWineName
            
            this.closeEditModal()
        },
        setupWines: function() {
            var allMonthCells = document.querySelectorAll(".admin-wine-month-single")
            allMonthCells.forEach(element => {
                element.childNodes[1].innerHTML = "None"
                element.childNodes[1].classList.add("red-text")
            });

            this.months.forEach(element => {
                var month = element.month
                var year = element.year
                var wineid = element.wineid
                if (year == this.currentYear) {
                    var cells = document.querySelectorAll(".admin-wine-month-single")
                    for (let index = 0; index < cells.length; index++) {
                        if (index == month) {
                            this.wines.forEach(wine => {
                                if (wine.id == wineid) {
                                    cells[index-1].childNodes[1].innerHTML = wine.name
                                    cells[index-1].childNodes[1].classList.remove("red-text")
                                }
                            });
                            
                        }
                        
                    }
                    month
                    wineid
                    cells
                }
            });
        }
    },
    created: function() {
        var thisYear = new Date().getFullYear()
        var lastYear = thisYear - 1
        var nextYear = thisYear + 1
        this.dataYears.push(lastYear)
        this.dataYears.push(thisYear)
        this.dataYears.push(nextYear)
        this.currentYear = thisYear
    },
    mounted: function() {
        var thisYearString = this.dataYears[1].toString()
        document.getElementById(thisYearString).classList.add("month-active-cell")

        $(".admin-wine-month-bar-cell").click(function() {
            $(".month-active-cell").toggleClass("month-active-cell")
            $(this).toggleClass("month-active-cell")
        })

        this.setupWines()
    }
}
</script>

<style>
.admin-wine-month-wrap {
    width: 90%;
    margin:auto;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: white;
    text-align: left;
}
.admin-wine-month-pad {
    width: 100%;
}
.admin-wine-month-single {
    height:20px;
}
.admin-wine-month-header {
    height:50px;
    width:100%;
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0px 4px 2px -2px rgba(0,0,0,0.1);
    -moz-box-shadow: 0px 4px 2px 0-2px rgba(0,0,0,0.1);
    box-shadow: 0 4px 2px -2px rgba(0,0,0,0.1);
    margin-bottom: 20px;

}
.admin-wine-month-bar {
    height:50px;
    display:flex;
    justify-content: center;
}
.admin-wine-month-bar-cell {
    text-align: center;
    flex-grow: 1;
    line-height: 50px;
    padding-left:20px;
    padding-right:20px;
    background-color: white;
    cursor: pointer;
}
.admin-wine-month-all {
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding:20px;
}
.admin-wine-month-single {
    text-align: center;
    width:24%;
    height:120px;
    margin-bottom: 20px;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
}
.admin-wine-month-single-header {
    padding-top: 5px;
    padding-bottom: 5px;
    font-weight: bold;
}
.admin-wine-month-single-body select {
    width:80%;
    margin:auto;
    margin-top: 15px;
}
.admin-wine-month-buttons {
    height:75px;
}
.admin-wine-month-save {
    margin: 0 auto;
    height: 50px;
    width: 150px;
    background-color: rgb(69, 144, 194);
    line-height: 50px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 20px;
}
.admin-wine-month-change {
    margin: 0 auto;
    height: 30px;
    width: 75px;
    background-color: rgb(69, 144, 194);
    line-height: 30px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-top: 20px;
}
.month-active-cell {
    background-color: rgb(69, 144, 194);
    color: white;
}



#admin-wine-month-edit-modal {
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(0,0,0,0.4);
}
.admin-wine-month-edit-modal-content {
    position:relative;
    width: 30%;
    height: 200px;
    margin: 15% auto;
    background-color: white;
    padding: 2rem;
}
.admin-wine-month-edit-modal-title {
    height:70%;
    font-size: 26px;
    margin-top: 20px;
}
.admin-wine-month-edit-modal-button {
    display: block;
    height: 50px;
    width: 150px;
    line-height: 50px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-left: 10px;
    bottom: 1rem;
    right: 1rem;
    float:right;
}
.red-text {
    color: #b33b3b;
    font-weight: bold;
}
</style>